import { Injectable } from '@angular/core';
import { ValidatorFn } from '@angular/forms';
import { IDatiqInputValidatorService } from '@dat/datiq-components-pkg/utils';
import { IDatiqDatepicker } from '../models';
import { DatiqDatepickerValidators } from '../validators';

@Injectable({
    providedIn: 'root',
})
export class DatiqDatepickerValidatorDaterangeService
    implements IDatiqInputValidatorService
{
    constructor() {}

    addValidator(_settings: IDatiqDatepicker, validations: ValidatorFn[]) {
        return [...validations, DatiqDatepickerValidators.range];
    }
}
